import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';

import { ready } from "./utils.js";

//The gallery links have no data-pswp-width/-height.
//Use the aspect ratio of the thumbnail, the large image is scaled to fit anyway.
function itemSizeFromThumbnail(itemData) {
    const img = itemData.element && itemData.element.querySelector('img');
    if (img && img.naturalWidth && !itemData.w) {
        const factor = 2000 / Math.max(img.naturalWidth, img.naturalHeight);
        itemData.w = Math.round(img.naturalWidth * factor);
        itemData.h = Math.round(img.naturalHeight * factor);
    }
    return itemData;
}

function enhanceGallery() {
    const lightbox = new PhotoSwipeLightbox({
        gallery: '.bl-gallery',
        children: 'a',
        showHideAnimationType: 'zoom',
        pswpModule: PhotoSwipe,
        paddingFn: () => {
            return {
              top: 15, bottom: 15, left: 15, right: 15
            }
        },
        bgOpacity: 0.9
    });
    lightbox.addFilter('itemData', itemSizeFromThumbnail);
    lightbox.init();
}

ready(enhanceGallery);
